// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NDjB","select":"styles_select__28nCa"};